const compactFmt = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const fullFmt = new Intl.NumberFormat("en-US");

export const fmtCount = (v?: number) => (v === undefined ? "–" : fullFmt.format(v));
export const fmtCompact = (v?: number) => (v === undefined ? "–" : compactFmt.format(v));

export type Money = "NGN" | "USD";

/** Money in a given currency; compact ("₦4.2M", "$3.1K") for charts and KPI cards */
export const fmtMoney = (currency: Money, value?: number, compact = false): string => {
  if (value === undefined) return "–";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol", // ₦ and $, not "NGN"
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: compact ? 1 : currency === "USD" ? 2 : 0,
  }).format(value);
};

/** % change between two periods; undefined if either side is missing or prev is 0 */
export const pctChange = (current?: number, previous?: number) =>
  current === undefined || previous === undefined || previous === 0
    ? undefined
    : ((current - previous) / previous) * 100;

export { num } from "../dashboardData";

export const pctOf = (part?: number, whole?: number) =>
  part === undefined || !whole ? undefined : (part / whole) * 100;
